import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SKIP_SESSION_REFRESH = new HttpContextToken<boolean>(() => false);

export function createSkipSessionRefreshContext(): HttpContext {
  return new HttpContext().set(SKIP_SESSION_REFRESH, true);
}

